import { relations, sql } from 'drizzle-orm'
import { boolean, index, pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../auth'
import { LessonModule } from '../content'

export const LovedLessonModule = pgTable(
  'loved_lesson_module',
  {
    id: uuid().primaryKey().defaultRandom(),
    userId: text()
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
    lessonModuleId: uuid()
      .notNull()
      .references(() => LessonModule.id, { onDelete: 'cascade' }),
    calculatedMetrics: boolean().default(false).notNull(),
    calculatedForMonthlyMetrics: boolean().default(false).notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
  },
  (t) => [
    index('idx_loved_lesson_module_user').on(t.userId),
    index('idx_loved_lesson_module_module').on(t.lessonModuleId),
    index('idx_loved_lesson_module_monthly_metrics').on(t.calculatedForMonthlyMetrics),
    uniqueIndex('loved_lesson_module_user_module_uidx').on(t.userId, t.lessonModuleId),
  ],
)

export const lovedLessonModuleRelations = relations(LovedLessonModule, ({ one }) => ({
  lessonModule: one(LessonModule, {
    fields: [LovedLessonModule.lessonModuleId],
    references: [LessonModule.id],
  }),
  user: one(user, {
    fields: [LovedLessonModule.userId],
    references: [user.id],
  }),
}))

export const InsertLovedLessonModuleSchema = createInsertSchema(LovedLessonModule).omit({
  id: true,
  createdAt: true,
})

export const SelectLovedLessonModuleSchema = createSelectSchema(LovedLessonModule)

export type InsertLovedLessonModule = typeof LovedLessonModule.$inferInsert
export type SelectLovedLessonModule = typeof LovedLessonModule.$inferSelect
